import { formatCurrency } from '@/domains/core/localization/currency';
import { getCurrency } from '@/domains/core/settings/utils';
import { type SubscriptionPlansQuery } from '@/domains/loyalty/modules/Subscriptions/generated/subscriptionPlans.query.generated';
import { BillingFrequency } from '@/generated/graphql/types';

export const getSubscriptionCheapestMonthlyPrice = (
  plans: SubscriptionPlansQuery['subscriptionPlans'],
) => {
  if (!plans.length) {
    return '';
  }

  const cheapestPrice = plans.reduce((acc, plan) => {
    const priceField = plan.sales
      ? plan.sales.discountedPrice.amountWithoutVat
      : plan.price.amountWithoutVat;
    const monthlyPriceForPlan =
      plan.subscriptionType === BillingFrequency.MONTHLY
        ? priceField
        : priceField / 12;

    return Math.min(acc, monthlyPriceForPlan);
  }, Infinity);

  return formatCurrency(cheapestPrice, getCurrency(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
};
